var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-group"},[_c('div',{staticClass:"button-container"},_vm._l((_vm.permissionButtons),function(btn){return _c('el-button',{key:btn.code,staticClass:"button-item",attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.btnClick(btn.code)}}},[_vm._v(_vm._s(btn.name)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }